module.exports = __webpack_public_path__ + "assets/language-squares/ar@2x-55b30b957d696c3b9316032d0445e440.jpg";